
import React from "react";
import {
  Box,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
  Stack,
} from "@mui/material";

import Img3 from "./cardImg/Card33.png";
import Img2 from "./cardImg/contactManagement22.png";
import { useNavigate } from "react-router-dom";

const Card2 = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.between("xs", "sm"));
  const isMd = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLg = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isXl = useMediaQuery(theme.breakpoints.up("lg"));

  const handleClick1 = () => {
    // navigate("/solution1");
    navigate("/products", { state: { index: 0 } });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xl: "row", lg: "row", md: "row", sm: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        backgroundImage: `url(${Img3})`, // Set the main background image
        backgroundSize: "cover", // Ensure the main image covers the entire Box
        backgroundPosition: "center", // Center the main image
        backgroundRepeat: "no-repeat", // Prevent tiling of the main image
        color: "#FFFFFF",
        borderRadius: "8px",
        overflow: "hidden",
        padding: isMd || isSm || isXs ? "16px" : "32px",
        width: "100%",
        // border: "1px solid red",
        position: "relative", // Enable positioning for the bottom-right image
        height: { xl: "380px", lg: "308px", md: "308px", xs: "200px" }, // Adjust the height of the card as needed
        marginTop: { xl: "0px", lg: "0px", md: "0px", sm: "0px", xs: "0px" },
      }}
    >
      {/* Text Section */}
      <Box
        sx={{
          height: {
            xl: "232px",
            lg: "232px",
            md: "232px",
            sm: "232px",
            xs: "160px",
          },
          // border: "2px solid red",
        }}
      >
        <Stack
          sx={{
            // border: "1px solid red",
            display: "flex",
            flexDirection: "row",
            gap: 2,
          }}
        >
          <Stack
            sx={{
              // border: "1px solid green",
              width: { xl: "30%", lg: "24%", md: "30%", xs: "17%" },
              // marginBottom: "8px",
            }}
          >
            <img
              src={Img2}
              alt="Forex Management"
              style={{
                width: "100%", // Image takes full width
                height: "100%",
                // padding: "4px",
                padding: isXs
                  ? "0px"
                  : isSm
                  ? "0px"
                  : isMd
                  ? "8px"
                  : isLg
                  ? "8px"
                  : "8px",
                objectFit: "contain",
              }}
            />
          </Stack>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              fontSize: {
                xl: "32px",
                lg: "24px",
                md: "16px",
                sm: "16px",
                xs: "16px",
              },
              marginBottom: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "none",
              },
              // border: "1px solid green",
            }}
          >
            No - code chatbot builder
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              fontSize: {
                xl: "32px",
                lg: "24px",
                md: "16px",
                sm: "16px",
                xs: "16px",
              },
              marginBottom: "8px",
              display: {
                xl: "none",
                lg: "none",
                md: "none",
                sm: "none",
                xs: "flex",
              },
            }}
          >
            No-code visual chatbot builder for businesses
          </Typography>
        </Stack>
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: isMd || isSm || isXs ? "12px" : "16px",
              marginBottom: { xl: "16px", lg: "16px", md: "16px", sm: "8px" },
              width: {
                xl: "76%",
                lg: "76%",
                md: "72%",
                sm: "100%",
                xs: "80%",
              },
              marginTop: {
                xl: "0px",
                lg: "0px",
                md: "0px",
                sm: "0px",
                xs: "0px",
              },
              // border: "1px solid white",
            }}
          >
            Build smart, AI-driven chatbots in minutes with our no-code platform
            for quick, easyand seamless customer interaction.
          </Typography>
        </Stack>

        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            // border: "2px solid red",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              color: "#FFFFFF",
              borderColor: "#FFFFFF",
              textTransform: "none",
              fontSize: isMd || isSm || isXs ? "12px" : "16px",
              width: "fit-content",
              borderRadius: "8px",
              marginTop: {
                xl: "0px",
                lg: "0px",
                md: "0px",
                sm: "0px",
                xs: "12px",
              },
              marginLeft: {
                xl: "100px",
                lg: "96px",
                md: "66px",
                sm: "0px",
                xs: "64px",
              },
               display: "none",
            }}
            size="large"
            onClick={handleClick1}
          >
            Know More
          </Button>
        </Stack>
      </Box>

      {/* Bottom-Right Image Section */}
      <Box
        sx={{
          // border: "4px solid white",
          position: "absolute",
          bottom: "0",
          right: "0",
          width: { xl: "60%", lg: "300px", md: "240px", xs: "260px" }, // Adjust width for the secondary image size
          height: { xl: "80%", lg: "200px", md: "160px", xs: "100px" }, // Adjust height for the secondary image size
          // backgroundImage: `url(${Img1})`, // Secondary image
          // backgroundSize: "cover", // Maintain aspect ratio of the secondary image
          // backgroundRepeat: "no-repeat", // Prevent tiling
          // backgroundPosition: "center", // Center the image in the box
          zIndex: 1, // Ensure it appears on top of the background but below text
        }}
      />
    </Box>
  );
};

export default Card2;
